// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"bbf8b0b4","223":"e45f5757","242":"06233202","327":"c54e1930","451":"059e84f2","476":"d9df476e","602":"5edada93","737":"029f473c","807":"d5bb6ccf"}[chunkId] + ".chunk.css";
};